import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material';
import {
  getColor,
  getConnection,
  getMode,
  getActiveSnapshot,
} from '../../utils/analyzerStatusUtils';

import { Analyzer } from 'types';

import { useAllSnapshotsWithoutCrosspol } from 'features/snapshots/api/getAllSnapshotsWithoutCrosspol';

interface Props {
  instruments: Analyzer[] | undefined;
}

const AlarmStatusWidgetTable = ({ instruments }: Props) => {
  const { data: snapshots } = useAllSnapshotsWithoutCrosspol({});

  return (
    <TableContainer>
      <Table size='small'>
        <TableHead>
          <TableRow>
            <TableCell>Analyzer</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>Mode</TableCell>
            <TableCell>Active Snapshot</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {instruments?.map((instrument) => (
            <TableRow
              sx={{ '&:last-child td': { border: 0 } }}
              key={instrument.id}
            >
              <TableCell style={{ color: getColor(instrument) }}>
                {instrument.name}
              </TableCell>
              <TableCell style={{ color: getColor(instrument) }}>
                {getConnection(instrument)}
              </TableCell>
              <TableCell style={{ color: getColor(instrument) }}>
                {getMode(instrument)}
              </TableCell>
              <TableCell style={{ color: getColor(instrument) }}>
                {getActiveSnapshot(instrument, snapshots)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
export default AlarmStatusWidgetTable;
